import React from "react";
import AssessmentRouter from './assessment/Router';
export { getFields } from './assessment/Router';

export default function AssessmentPMPriceRouter(props){
    return <AssessmentRouter {...props} mode='PM_PRICE' />;
}